import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var generateStyle = function generateStyle(componentTheme) {
  var mp = '@media print';
  return {
    uiFont: {
      fontFamily: componentTheme.fontFamily
    },
    actAsInput: {
      transition: componentTheme.wrapperTransition,
      outline: '0.1875rem solid transparent',
      outlineOffset: '-0.5rem',
      border: "".concat(componentTheme.borderWidth, " ").concat(componentTheme.borderStyle, " ").concat(componentTheme.borderColor),
      borderRadius: componentTheme.borderRadius,
      padding: componentTheme.paddingOfInput,
      maxHeight: '100px',
      overflowY: 'auto'
    },
    invalidRceInput: {
      borderColor: componentTheme.errorBorderColor
    },
    placeholderRceInput: {
      color: componentTheme.colorOfRceInputPlaceholder
    },
    globalStyles: {
      '.invalid-rce .tox .tox-edit-area, .invalid-rce .tox .tox-edit-area iframe': {
        borderColor: "".concat(componentTheme.errorBorderColor, " !important")
      },
      '.readonly-rce .tox-edit-area.active': {
        borderColor: "".concat(componentTheme.disabledBorderColor, " !important"),
        outline: 'none !important'
      },
      '.readonly-rce .tox-edit-area.active iframe': {
        borderColor: 'transparent !important',
        outline: 'none !important'
      },
      '.readonly-rce .tox .toxMbtn:disabled, .readonly-rce .toxTbtn:disabled, .readonly-rce .toxTbtn:disabled svg, .readonly-rce .tox-tbtn--disabled svg': {
        opacity: '1  !important',
        color: "".concat(componentTheme.black, " !important"),
        pointerEvents: 'none !important'
      },
      '.readonly-rce .tox-tbtn--disabled': {
        opacity: '1  !important'
      },
      '.readonly-rce .toxTbtn:disabled svg': {
        fill: "".concat(componentTheme.black, " !important")
      },
      '.tox-fullscreen .tox.tox-tinymceAux': {
        zIndex: '9999 !important'
      },
      '.tox-editor-header': _defineProperty({}, mp, {
        display: 'none !important'
      }),
      '[data-testid="RCEStatusBar"]': _defineProperty({}, mp, {
        display: 'none !important'
      })
    }
  };
};
export default generateStyle;